import { GroupsSort } from "@shared/features/newMarketplace/types";

export const GROUP_CARD_HEIGHT = 316;
export const GROUP_CARD_WIDTH = 380;
export const SMALL_SCREEN_GROUP_CARD_HEIGHT = 210;

export const GROUP_DRAWER_EXTENSION_WIDTH = 880;

export const FIELD_NAME_TO_SORT = {
  backtesting_score: GroupsSort.SCORE,
  name: GroupsSort.NAME,
  avg_stars: GroupsSort.RATING,
  price_number: GroupsSort.PRICE,
  "timeframe_to_backtesting_run_data.180": GroupsSort.SIX_MONTH_PNL,
  "timeframe_to_backtesting_run_data.90": GroupsSort.THREE_MONTH_PNL,
  "timeframe_to_backtesting_run_data.30": GroupsSort.ONE_MONTH_PNL,
  backtesting_score_breakdown: GroupsSort.RISK,
};
